/* eslint-disable no-undef */
const ref = typeof Vue !== 'undefined' ? Vue.ref : null;
const watch = typeof Vue !== 'undefined' ? Vue.watch : null;

const template = `
	<div class="ubf-dynamicList__filter ubf-dynamicList__filter--multiselect">
		<div class="ubf-dynamicList__checkboxGroup" role="group" :aria-label="label">
			<label class="ubf-dynamicList__checkboxGroup__item" v-for="option in preset">
				<input type="checkbox" :value="option.id" :checked="isChecked(option.id)" @change="onToggle(option, $event)" />
				{{ option.label }}
			</label>
		</div>
		<div class="ubf-dynamicList__info">
			{{ info }}
		</div>
	</div>
`;

export default {
    emits: ['change'],
    template: template,
    props: {
        label: String,
        value: [Object],
        description: String,
        preset: Array,
		info: String
    },
    setup: function (props, context) {
        const initial = props.value ? Array.from(props.value) : [];
        const localSelected = ref(new Set(initial));
        watch(
            () => props.value,
            (newVal) => {
                const arr = newVal ? Array.from(newVal) : [];
                localSelected.value = new Set(arr);
            }
        );
        const isChecked = (option) => localSelected.value.has(option);
        const onToggle = (option, event) => {
            const set = localSelected.value;
            if (event.target.checked) {
                set.add(option.id);
            } else {
                set.delete(option.id);
            }
            // trigger update by creating a new Set reference
            localSelected.value = new Set(Array.from(set));
            context.emit('change', Array.from(localSelected.value));
        };
        return {
            label: props.label,
            description: props.description,
            preset: props.preset,
            localSelected: localSelected,
            isChecked: isChecked,
            onToggle: onToggle,
        };
    },
};

